<template>
  <div>
    <q-dialog
      v-model="pagesUtilStore.showModalDeleteInstitutionalConfirmation"
      :no-backdrop-dismiss="true"
    >
      <q-card class="midia-app-padding-modal" style="width: 448px;">
        <div>
          <c-modal-title
            :propModalTitle="modalTitle"
            :propModalDescription="modalDescription"
          />

          <div class="row fit no-wrap justify-center q-pb-sm">
            <c-q-btn
              id="btn-excluir"
              style="width: 100%;"
              propBtnLabel="EXCLUIR"
              :propBtnFunction="onConfirmDelete"
              :propBtnTransparent="false"
              :propBtnSize="EnumButtonSizes.LARGE_1"
            />
          </div>

          <div class="row fit no-wrap justify-center">
            <c-q-btn
              id="btn-cancelar"
              style="width: 100%;"
              propBtnLabel="CANCELAR"
              :propBtnTransparent="true"
              :propBtnSize="EnumButtonSizes.LARGE_1"
              @click="onCancel"
            />
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePagesUtilStore } from '@/stores/pagesUtilStore';
import { useInstitutionalStore } from '@/stores/institutionalStore';
import { EnumMultipleSingleMode, EnumButtonSizes } from '@/enums/enums';
import messages from '@/utils/messages';

const pagesUtilStore = usePagesUtilStore();
const institutionalStore = useInstitutionalStore();

/**
 * TEXTOS DO MODAL
 * (PDF pede exatamente essa mensagem)
 */
const modalTitle = computed(() => {
  return pagesUtilStore.modalDeleteInstitutionalConfirmationMode ===
    EnumMultipleSingleMode.MULTIPLE
    ? 'Excluir Cadastro(s)'
    : 'Excluir Cadastro';
});

const modalDescription = computed(() => {
  return pagesUtilStore.modalDeleteInstitutionalConfirmationMode ===
    EnumMultipleSingleMode.MULTIPLE
    ? 'Deseja realmente excluir o(s) Cadastro(s) selecionado(s)?'
    : 'Deseja realmente excluir este Cadastro?';
});


const onConfirmDelete = async () => {
  try {
    let ids: number[] = []

    if (pagesUtilStore.modalDeleteInstitutionalConfirmationMode === EnumMultipleSingleMode.SINGLE) {
      // ✅ SINGLE → pega o id do detail
      const id = institutionalStore.institutionalDetail?.id
      if (!id) {
        messages.showErrorMsg('Nenhum cadastro selecionado para exclusão.')
        closeModal()
        return
      }
      ids = [id]
    } else {
      // ✅ MULTIPLE → pega os selecionados
      if (!institutionalStore.selectedInstitutionals.length) {
        messages.showErrorMsg('Nenhum cadastro selecionado para exclusão.')
        closeModal()
        return
      }

      const canDelete = institutionalStore.canDeleteSelectedInstitutionals()
      if (!canDelete) {
        messages.showErrorMsg('Existem cadastros selecionados que não podem ser excluídos.')
        closeModal()
        return
      }

      ids = institutionalStore.selectedInstitutionals.map(item => item.id)
    }

    await institutionalStore.deleteInstitutionals(ids)

    messages.showSuccessMsg('Cadastro(s) excluído(s) com sucesso!')

  } catch (error) {
    messages.showErrorMsg('Erro ao tentar excluir o cadastro institucional.')
  } finally {
    closeModal()
  }
}



/**
 * CANCELAR
 */
const onCancel = () => {
  closeModal();
};

const closeModal = () => {
  pagesUtilStore.showModalDeleteInstitutionalConfirmation = false;
};
</script>

<style scoped>
/* sem estilos específicos */
</style>
